(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/helpers/handlebarshelpers.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/helpers/handlebarshelpers.js');

'use strict';

function registerHelpers(hbs, LoginTypes) {
  hbs.registerHelper('propertyExists', function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const params = args.slice(0, args.length - 1);
    const options = args[args.length - 1];
    let i = params.length;
    while (i--) {
      if (params[i] === undefined || params[i] === null) {
        return options && typeof options.inverse === 'function' ? options.inverse(this) : false;
      }
    }
    return options && typeof options.fn === 'function' ? options.fn(this) : true;
  });
  hbs.registerHelper('formatTimeLimit', (limit, period) => {
    if (!isNaN(limit)) {
      limit = parseInt(limit, 10);
      if (period === 'day') {
        const hours = Math.floor(limit / 60);
        const minutes = limit % 60;
        return "".concat(hours, " tim och ").concat(minutes, " min");
      }
      return "".concat(limit / 60, " tim");
    }
  });
  hbs.registerHelper('compareLoginMethod', (method, ref, options) => {
    const result = method === LoginTypes[ref];
    if (result && options && typeof options.fn === 'function') {
      return options.fn(this);
    } else if (!result && options && typeof options.inverse === 'function') {
      return options.inverse(this);
    }
    return result;
  });
}
if (typeof exports === 'object') {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  registerHelpers(require('hbs'), trinidad.components.require('accountservices', 'authenticate').definitions.LoginTypes);
} else {
  registerHelpers(Handlebars, svs.accountservices.authenticate.definitions.LoginTypes);
}

 })(window);